<div class='auth'>
  <div class='auth-left-side'>
    <div class='auth-logo'>
      <img src='/assets/img/frogo-logo.svg' alt="{{ 'alts.logo' | translate }}">
    </div>

    <div class="auth-left-side-slider">
      <fk-slider [items]="sliderItems" [isArrowsEnabled]="true"></fk-slider>
    </div>
  </div>
  <div class="auth-right-side">
    <div class="auth-dialog-wrapper">
      <div class="auth-dialog-frogo-head">
        <img src="/assets/img/frogo-head.svg" alt="frogo head">
      </div>
      <div class='auth-dialog fk-pv8 fk-ph7'>
        <div class="auth-dialog-left-hand">
          <img src="/assets/img/frogo-left-hand.svg" alt="frogo left hand">
        </div>
        <div class="auth-dialog-right-hand">
          <img src="/assets/img/frogo-right-hand.svg" alt="frogo right hand">
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>

    <div class="auth-right-side-hint fk-h5">
      {{ 'auth.hint' | translate }}
    </div>
  </div>
</div>
